import { render, staticRenderFns } from "./squadlist.vue?vue&type=template&id=178935ce"
import script from "./squadlist.vue?vue&type=script&lang=js"
export * from "./squadlist.vue?vue&type=script&lang=js"
import style0 from "./squadlist.vue?vue&type=style&index=0&id=178935ce&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports